module.exports = __webpack_public_path__ + "img/shfw.a0c6ee78.png";